<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M11.7778 2C6.26019 2 1.77783 6.48235 1.77783 12C1.77783 17.5176 6.26019 22 11.7778 22C17.2955 22 21.7778 17.5176 21.7778 12C21.7778 6.48235 17.2955 2 11.7778 2ZM11.7778 20.8235C6.90724 20.8235 2.9543 16.8706 2.9543 12C2.9543 7.12941 6.90724 3.17647 11.7778 3.17647C16.6484 3.17647 20.6014 7.12941 20.6014 12C20.6014 16.8706 16.6484 20.8235 11.7778 20.8235ZM17.0719 12.5882C17.0719 15.5059 14.6955 17.8824 11.7778 17.8824C8.86019 17.8824 6.48371 15.5059 6.48371 12.5882C6.48371 12.2588 6.74254 12 7.07195 12C7.40136 12 7.66019 12.2588 7.66019 12.5882C7.66019 14.8588 9.50724 16.7059 11.7778 16.7059C14.0484 16.7059 15.8955 14.8588 15.8955 12.5882C15.8955 12.2588 16.1543 12 16.4837 12C16.8131 12 17.0719 12.2588 17.0719 12.5882ZM7.07195 8.47059C7.07195 7.82353 7.60136 7.29412 8.24842 7.29412C8.89548 7.29412 9.42489 7.82353 9.42489 8.47059C9.42489 9.11765 8.89548 9.64706 8.24842 9.64706C7.60136 9.64706 7.07195 9.11765 7.07195 8.47059ZM14.1308 8.47059C14.1308 7.82353 14.6602 7.29412 15.3072 7.29412C15.9543 7.29412 16.4837 7.82353 16.4837 8.47059C16.4837 9.11765 15.9543 9.64706 15.3072 9.64706C14.6602 9.64706 14.1308 9.11765 14.1308 8.47059Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
